import { render, staticRenderFns } from "./MenuBlock.vue.vue?vue&type=template&id=62f3b432&scoped=true"
import script from "./MenuBlock.vue.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBlock.vue.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MenuBlock.vue.vue?vue&type=style&index=0&id=62f3b432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f3b432",
  null
  
)

export default component.exports